import api from "@/api";

const state = {
    details: {},
    existingUsers: [],
};

const getters = {
    details(state) {
        return token => state.details[token];
    },
    existingUsers(state) {
        return state.existingUsers;
    },
};

const actions = {
    get({ commit }, { payload: { team, token } }) {
        return api.get(`/api/users/get/invite/${team}/${token}`).then(res => {
            commit("updateDetails", { token, invite: res.data });
        });
    },
    upload(_, { payload: { file } }) {
        const formData = new FormData();
        formData.append("file", file);

        return api.post("/api/uploads/users", formData);
    },
    send(_, { payload: { text, user, localTeam } }) {
        return api.post("/api/users/create/invite/resend", {
            text,
            user,
            localTeam,
        });
    },
    sendMany({ commit }, { payload: { users, role, text, teamId, sendNow } }) {
        return api
            .post(`/api/users/create/invite`, { users, role, text, teamId, sendNow })
            .then(res => {
                const existingUsers = res.data || [];

                commit("updateExistingUsers", { list: existingUsers });
            });
    },
};

const mutations = {
    updateDetails(state, { token, invite }) {
        state.details[token] = invite;
    },
    updateExistingUsers(state, { list }) {
        state.existingUsers = [...list];
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
